import gsap, { SplitText } from "@lib/gsap";
import { onMount, onView, onTrack, onDestroy, onPageIn, onPageOut } from "./_";

export default function (element, dataset) {
  const clone = element.querySelector(".im_block").cloneNode(true);
  element.appendChild(clone);

  let tl = gsap.timeline({
    repeat: -1,
    defaults: {
      ease: "none",
    },
  });

  tl.to(element.querySelectorAll(".im_block"), {
    xPercent: -100,
    duration: 15,
  });

  element.addEventListener("mouseenter", () => tl.pause());
  element.addEventListener("mouseleave", () => tl.resume());
}
